/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const environmentRequestNameMax = 255;

export const EnvironmentRequest = zod
	.object({
		name: zod.string().min(1).max(environmentRequestNameMax).describe('Environment name'),
		type: zod.enum(['production', 'sandbox'])
	})
	.describe('Environment creation\/update request');

export type EnvironmentRequest = zod.input<typeof EnvironmentRequest>;
export type EnvironmentRequestOutput = zod.output<typeof EnvironmentRequest>;
